import { Component } from '@angular/core';
import { NavController,NavParams,LoadingController,ModalController,ViewController,AlertController,ToastController} from 'ionic-angular';
import * as firebase from 'firebase/app';
import { NewIncidentPage } from './create';
import { FormBuilder, FormGroup,Validators } from '@angular/forms';

import * as moment from 'moment';
import '../../../node_modules/moment/locale/es';
import { Params } from '../params';
import {NotificationsProvider} from "../../providers/notifications/notifications";
import {c} from "@angular/core/src/render3";

@Component({
  selector: 'page-incidents',
  templateUrl: 'incidents.html'
})
export class IncidentsPage {
  incidents;
  customers;
  accounts;
  status = [];
  categories = [];
  items = [];
  filter_category : string = "all";
  filter_status : string = "all";
  filter_name : string;
  constructor(
    private nav: NavController,
    public modalCtrl: ModalController,
    private alertCtrl : AlertController
  ){
    firebase.database().ref('/incidents/categories').once('value')
      .then((snap1)=> {
        this.categories = snap1.val();
        console.log("categories",this.categories);
      })
    firebase.database().ref('/incidents/status').once('value')
      .then((snap1)=> {
        this.status = snap1.val();
        console.log("incidents",this.status);
      })

    firebase.database().ref('/accounts').once('value')
      .then((snap1)=> {
        this.accounts = snap1.val();
      })
    firebase.database().ref('/customers').once('value')
      .then((snap1)=> {
        this.customers = snap1.val();
        firebase.database().ref('/incidents/data').once('value')
          .then((snap)=>{
            const val = snap.val();
            this.filter_name = "";
            this.filter_category = "all";
            this.filter_status = "all";
            this.items = [];
            this.processIncidents(val);
          })
        firebase.database().ref('/incidents/data').on('value',(snap)=>{
          const val = snap.val();
          this.items = [];
          this.processIncidents(val);
        });
      });


  }

  processIncidents(val){
    this.incidents = Object.keys(val).map(key =>{ return { key:key, ...val[key]}});
    this.initializeItems();
  }

  initializeItems() {
    this.items = this.incidents;
    this.items.sort()
  }

  getItems(ev: any) {
    this.initializeItems();
    this.filter_category = "all";
    this.filter_status = "all";
    let val = ev.target.value;
    if (val && val.trim() != '') {
      this.items = this.items.filter((item) => {
        return ((this.customers[item.customer].name.toLowerCase().indexOf(val.toLowerCase()) > -1) || (this.customers[item.customer].lastname.toLowerCase().indexOf(val.toLowerCase()) > -1));
      })
    }
  }

  lastHistoryDate(i){
    let l = Object.keys(i.history).length-1;
    let c = Object.keys(i.history)[l]
    let h = i.history[c];
    return this.todate(h.datetime)
  }

  todate(date){
      return moment(date).format("DD-MM-YYYY");
  }

  history(inc){
    inc.categories = this.categories;
    inc.statuses = this.status;
    inc.kind = 2;
    let modal = this.modalCtrl.create(ModalViewIncidentPage, inc);
    modal.present();
  }

  ver(inc){
    inc.categories = this.categories;
    inc.statuses = this.status;
    inc.customer_info = this.customers[inc.customer];
    inc.accounts = this.accounts;
    inc.kind = 1;
    let modal = this.modalCtrl.create(ModalViewIncidentPage, inc);
    modal.present();
  }

  filter(e,t){
    this.initializeItems();
    this.filter_name = "";
    if(e!="all"){

      if(t=="cat") {
        this.items = this.items.filter((item) => {
          return (item.category == this.categories.indexOf(e));
        })
        this.filter_status = "all";
      }
      if(t=="st") {
        this.items = this.items.filter((item) => {
          return (item.status == this.status.indexOf(e));
        })
        this.filter_category = "all";
      }

    }

  }

  remove(index){
    let alert = this.alertCtrl.create({
      title: 'Eliminar inciencia',
      subTitle: 'Está seguro de querer eliminar la incidencia #'+index,
      buttons: [{
        text: 'Eliminar',
        handler: data => {
          firebase.database().ref('/incidents/data/'+index).remove()
            .then(()=>{

            })
          // this.incidentsRef.remove(index).then(_ => console.log('item deleted!'));
        }
      },{
        text: 'Cancelar',
        role: 'cancel'
      }]
    });
    alert.present();
  }

  crear(){
    this.nav.push(NewIncidentPage);
  }
}


@Component({
  template: `
<ion-header>
  <ion-toolbar>
    <ion-title *ngIf="kind==1">
      Viendo incidencia #{{incident.key}}
    </ion-title>
    <ion-title *ngIf="kind==2">
      Actualizar incidencia #{{incident.key}}
    </ion-title>
    <ion-buttons end>
      <button *ngIf="kind==2" ion-button [disabled]="!addForm.valid" (click)="save()">
        Guardar Incidencia
      </button>
  </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content>
  <ion-grid *ngIf="kind==1">
  <ion-row>
    <ion-col col-2>Cliente</ion-col>
    <ion-col col-1>:</ion-col>
    <ion-col >{{incident.customer_info.name}} {{incident.customer_info.lastname}}</ion-col>
  </ion-row>
  <ion-row>
    <ion-col col-2>Categoría</ion-col>
    <ion-col col-1>:</ion-col>
    <ion-col col-3>{{categories[incident.category]}}</ion-col>
    <ion-col col-2>Estado</ion-col>
    <ion-col col-1>:</ion-col>
    <ion-col col-3>{{statuses[incident.status]}}</ion-col>
  </ion-row>
  <ion-row>
    <ion-col col-2>Fecha Incidente</ion-col>
    <ion-col col-1>:</ion-col>
    <ion-col col-3>{{format(incident.datecreate)}}</ion-col>
    <ion-col col-2>Usuario</ion-col>
    <ion-col col-1>:</ion-col>
    <ion-col col-3>{{accounts[incident.owner].name}}</ion-col>
  </ion-row>
  <ion-row>
    <ion-col col-2>Detalle</ion-col>
    <ion-col col-1>:</ion-col>
    <ion-col col-9>{{incident.description}}</ion-col>
  </ion-row>
  <ion-row>
    <ion-col><h4>Historia</h4></ion-col>
  </ion-row>
  <ion-row>
    <ion-col style="border-bottom:1px solid #ccc;" col-12>
      <p>[ {{format(incident.datecreate)}} ] <b>{{accounts[incident.owner].name}}</b> abrió la incidencia</p>
    </ion-col>
    <ion-col style="border-bottom:1px solid #ccc;" col-12 *ngFor="let h of incidentHistory">
      <p>[ {{format(incident.history[h].datetime)}} ] <b>{{accounts[incident.history[h].owner].name}}</b> cambió estado por {{statuses[incident.history[h].status]}}</p>
      <p>Dijo: {{incident.history[h].detail}}</p>
    </ion-col>
  </ion-row>
  </ion-grid>
  <ion-list *ngIf="kind==2">
    <ion-item>
      <ion-label>Nuevo Estado</ion-label>
      <ion-select [(ngModel)]="history.status" >
          <ion-option  *ngFor="let st of statuses" [value]="statuses.indexOf(st)">{{st}}</ion-option>
        </ion-select>
    </ion-item>
    <ion-item>
      <ion-label>Tipo de Problema</ion-label>
      <ion-select [(ngModel)]="category">
        <ion-option *ngFor="let category of categories" [value]="categories.indexOf(category)">{{category}}</ion-option>
      </ion-select>
    </ion-item>
    <ion-item>
      <ion-label stacked>Detalle</ion-label>
      <ion-textarea [(ngModel)]="history.detail" rows="10"></ion-textarea>
    </ion-item>
    </ion-list>
</ion-content>
`
})
export class ModalViewIncidentPage {
  addForm: FormGroup;
  incident;
  category;
  categories;
  statuses;
  accounts;
  match;
  kind;
  history = {
    status : 0,
    detail : ""
  };
  incidentHistory = [];
  constructor(
    private builder: FormBuilder,
    private params : NavParams,
    private loadingCtrl : LoadingController,
    public viewCtrl: ViewController,
    private notif : NotificationsProvider,
    public toastCtrl: ToastController
  ) {
    this.kind = params.data.kind;
    this.incident = params.data;
    if(params.data.history) this.incidentHistory = Object.keys(params.data.history);
    console.log(this.incident);
    this.history.status = this.incident.status;
    this.categories = this.incident.categories;
    this.category = this.incident.category;
    this.accounts = this.incident.accounts;
    this.statuses = this.incident.statuses;
    let solution = "";
    if(typeof this.incident.solution!="undefined") solution = this.incident.solution;
    this.addForm = builder.group({
      'datecreate': [this.incident.datecreate, Validators.required],
      'description': [this.incident.description, Validators.required],
      'category': [this.incident.category, Validators.required],
      'status': [this.incident.status, Validators.required],
      'solution': [solution]
    });
    firebase.database().ref('/incidents/match').once('value')
      .then((snap1)=> {
        this.match = snap1.val();
      });
  }

  format(date){
    return moment(date).format("DD MMMM YY HH:mm:ss");
  }

  save() {
    let loading = this.loadingCtrl.create({
      content: 'Guardando los cambios...'
    });
    loading.present();

    if(this.kind==1){
      let tosave = {
        "category" : this.incident.category,
        "status": this.addForm.value.status,
        "solution" : this.addForm.value.solution,
        "description" : this.addForm.value.description,
        "datecreate" : this.incident.datecreate,
        "customer" : this.incident.customer,
        "owner" : this.incident.owner,
        "origin" : this.incident.origin,
        "datetime" : this.incident.datetime,
        "dateresolve" : moment().format()
      };

      if(this.addForm.value.status==2){
        /*let mails_groups = this.match[this.incident.category];

         for(let m=0;m<mails_groups.length;m++){
          firebase.database().ref('/groups/data/'+mails_groups[m]).once('value')
            .then((snap2)=> {
              if(snap2.exists()){
                let mails = snap2.val();
                let temp_mails = [];
                for(let n=0;n<Object.keys(mails).length;n++){
                  if(mails[Object.keys(mails)[n]]) temp_mails.push(mails[Object.keys(mails)[n]]);
                }
                let obj = {
                  "category" : tosave.category,
                  "emails" : temp_mails,
                  "correlative" : this.incident.$key,
                  "title" : "Incidencia Resuelta",
                  "content" : "Se ha resuelto una incidencia"
                }
                this.http.post("http://fitfood.cl/admin/emails/index.php",obj).subscribe(data => {
                  let msg = "Se han enviado emails correctamente";
                  if(!data["ok"]){
                    msg = "No se pudo enviar emails."+data["msg"];
                  }
                  let toast = this.toastCtrl.create({
                    message: msg,
                    duration: 3000
                  });
                  toast.present();
                });
              }
            });
        } */
      }


      /* this.new = this.db.object('incidents/data/'+this.incident.$key);
      this.new.set(tosave).then( _ => {
        this.viewCtrl.dismiss();
        loading.dismiss();
      }); */
    }

    if(this.kind==2){
      this.history["owner"] = Params.md5(Params.USER_DATA.email);
      this.history["datetime"] = moment().format();
      if(this.category){
        firebase.database().ref('incidents/data/'+this.incident.key+'/category').set(this.category);
      }
      const key = firebase.database().ref('incidents/data/'+this.incident.key).child('history').push().key;
      this.history['key'] = key;

      firebase.database().ref('incidents/data/'+this.incident.key+'/history/'+key).update(this.history)
        .then(()=>{
          this.notif.sendNotification( "Incidencia #"+this.incident.key+" "+this.statuses[this.history["status"]],Params.USER_DATA.name+' dice: '+this.history["detail"]);
          this.viewCtrl.dismiss();
          loading.dismiss();
        })

      firebase.database().ref('incidents/data/'+this.incident.key+'/status').set(this.history["status"]);

    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/incidents/incidents.ts